import React from "react";


export function LoadingButton(props){

    return (
        <button type="button" className="btn btn-primary loading">
            {props.text}
            <div className="lf-spinner lf-spinner-btn-primary">
                <svg viewBox="0 0 105 105" x="0" y="0" role="animation">
                    <circle className="static-circle" r="45%" cx="50%" cy="50%"></circle>
                    <circle className="lf-spinner-dash" r="45%" cx="50%" cy="50%"></circle>
                </svg>
            </div>
        </button>
    );
}
